import {Component, OnDestroy, OnInit} from "@angular/core";
import {FacturationClientService} from "../../../core/services/entities/facturation-client.service";
import {Subscription} from "rxjs";
import {UtilsService} from "../../../core/utils/utils.service";
import {AnalyseFinanciereDetail} from "../../../core/models/facturation/client/analyse-financiere-detail";

@Component({
  templateUrl: './tableau-de-bord.component.html',
  styleUrls: ['./tableau-de-bord.component.scss']
})

export class TableauDeBordComponent implements OnInit, OnDestroy {
  currentIndex: number = 0;
  subExportPlat: Subscription;
  subExportPrestation: Subscription;

  analyseFinancierePlat: AnalyseFinanciereDetail[] = [];
  analyseFinancierePrestation: AnalyseFinanciereDetail[] = [];

  constructor(public facturationClientSvc: FacturationClientService, private utilSvc: UtilsService) {}

  ngOnInit(): void {
    this.initData();
    this.initSubExport();
  }

  ngOnDestroy(): void {
    this.utilSvc.unsubscribe(this.subExportPrestation);
    this.utilSvc.unsubscribe(this.subExportPlat);
  }

  initSubExport = () => {

    this.subExportPrestation = this.facturationClientSvc.exportAnalyseFinancierePrestation$.subscribe((result: AnalyseFinanciereDetail[]) => {
      if (result) {
        this.currentIndex = 0;
        this.analyseFinancierePrestation = result;
        this.facturationClientSvc.dataAnalysePrestation = result;
      }
    });

    this.subExportPlat = this.facturationClientSvc.exportAnalyseFinancierePlat$.subscribe((result: AnalyseFinanciereDetail[]) => {
      if (result) {
        this.currentIndex = 1;
        this.analyseFinancierePlat = result;
        this.facturationClientSvc.dataAnalysePlat = result;
      }
    });
  }

  displayExportSettings() {
    this.facturationClientSvc.announceOpenExportSettings();
  }

  private initData() {
    this.analyseFinancierePlat = this.facturationClientSvc.dataAnalysePlat;
    this.analyseFinancierePrestation = this.facturationClientSvc.dataAnalysePrestation;
  }
}
